import  CoverDetailCard from './CoverDetailCard';

export default CoverDetailCard